import { Box, Typography } from '@mui/material';
import React from 'react';
import { lightPalette } from '../../../theme';
import { Root, classes } from './utils';

const SalesAdminDashboard = () => {
  console.log('empty');
  return (
    <Root className={classes.root}>
      <Box className={classes.MainBox}>
        <Box className={classes.adminDashboardTitleBox}>
          <Typography variant="h4" color={lightPalette.darkPurple.main}>
            Sales Admin Dashboard
          </Typography>
        </Box>
      </Box>
    </Root>
  );
};

export default SalesAdminDashboard;
